export default __webpack_public_path__ + "static/media/alert-dialog-claim-icon.21b7ffe7.png";